import { AgentPublicConfigSchema, AgentSessionResponseSchema, } from '@cloneai/shared-types/api';
export function createPublicAgentsResource(http) {
    return {
        getConfig: (tenantSlug, agentSlug) => http.request({
            method: 'GET',
            path: `/v1/public/agents/${encodeURIComponent(tenantSlug)}/${encodeURIComponent(agentSlug)}`,
            responseSchema: AgentPublicConfigSchema,
            anonymous: true,
        }),
        mintSession: (tenantSlug, agentSlug, body) => http.request({
            method: 'POST',
            path: `/v1/public/agents/${encodeURIComponent(tenantSlug)}/${encodeURIComponent(agentSlug)}/session`,
            body,
            responseSchema: AgentSessionResponseSchema,
            anonymous: true,
        }),
    };
}
//# sourceMappingURL=publicAgents.js.map